<article class="px-16 py-12.5 lg:w-126.5 bg-white rounded-lg text-center">
  <div class="flex justify-center gap-x-3">
    <fa-icon
      [icon]="faCircleExclamation"
      size="2xl"
      class="text-yellow-300 mt-1" />
    <h2 class="text-[28px] font-bold mb-4">Re-Open Application</h2>
  </div>
  <div class="mb-6 whitespace-pre-line text-left flex flex-col gap-y-2">
    <p>
      You are about to re-open this application. Re-opening the application will
      allow edits to the existing case information.
    </p>
    <p>Please note:</p>
    <ul class="list-disc list-inside">
      <li>The Court File Number cannot be changed.</li>
      <li>A new appointment cannot be scheduled.</li>
      <li>
        Any updates to application information may generate new Tax Details.
      </li>
      <li>The application status will change from Closed to Re-Opened.</li>
    </ul>
    <p>This action cannot be undone.</p>
    <p>Please confirm that you want to proceed.</p>
  </div>

  <div class="flex justify-end gap-11">
    <ui-button class="w-full" mat-dialog-close [outline]="true">
      Cancel
    </ui-button>
    <ui-button [mat-dialog-close]="true" class="w-full">Re-Open</ui-button>
  </div>
</article>
